/*import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }],
  bootstrap: [AppComponent],
})
export class AppModule {}*/

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy, IonRouterOutlet } from '@ionic/angular';
//import { SplashScreen } from '@ionic-native/splash-screen/ngx';
//import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AppointmentPage } from './pages/appointment/appointment.page';
import { AppointmentDetailsPage } from './pages/appointment_details/appointment_details.page';
import { ForgotPasswordPage } from './pages/forgot_password/forgot_password.page';
import { ManageUserProfilePage } from './pages/manage_user_profile/manage_user_profile.page';
import { ManagePetProfilePage } from './pages/manage_pet_profile/manage_pet_profile.page';
import { PetProfilePage } from './pages/pet_profile/pet_profile.page';
import { ExamRoomPage } from './pages/exam_room/exam_room.page';
import { RatingPage } from './pages/rating/rating.page';
import { VetProfilePage } from './pages/vet_profile/vet_profile.page';
import { MedicalRecordPage } from './pages/medical_record/medical_record.page';
import { MediaViewerPage } from './pages/media_viewer/media_viewer.page';
import { ChangePasswordPage } from './pages/change_password/change_password.page';
import { SubscriptionsPage } from './pages/subscriptions/subscriptions.page';



import { SharedService } from './services/shared.service';
import { CallService } from './services/call.service';
import { Places } from './services/places';
import { Connection } from './services/connection';


import { Vibration } from '@ionic-native/vibration/ngx';
import { Network } from '@ionic-native/network/ngx';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { Chooser } from '@awesome-cordova-plugins/chooser/ngx';

import { HttpClientModule, HttpClientJsonpModule, HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';

import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
//import { Geolocation } from '@ionic-native/geolocation/ngx';
//import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
//import { Geolocation } from '@capacitor/geolocation';
//import { Geolocation } from '@ionic-native/geolocation';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { IonicStorageModule } from '@ionic/storage-angular';

import { HTTP } from '@ionic-native/http/ngx';

import { File } from '@awesome-cordova-plugins/file/ngx';
import { VideoEditor } from '@awesome-cordova-plugins/video-editor/ngx';

import { StreamingMedia, StreamingVideoOptions } from '@awesome-cordova-plugins/streaming-media/ngx';

import { PushNotifications } from '@capacitor/push-notifications';
import { Badge } from '@awesome-cordova-plugins/badge/ngx';

import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';

import { LaunchNavigator, LaunchNavigatorOptions } from '@awesome-cordova-plugins/launch-navigator/ngx';

import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';

import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';

//------------------------------------------//

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule, HttpClientModule, IonicStorageModule.forRoot()],
  providers: [
    //StatusBar,
    //SplashScreen,
    NativeStorage,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
          provide: IonRouterOutlet,
          useValue: {
            //add whatever property of IonRouterOutlet you're using in component class
            nativeEl: ""
          }
        },
    HTTP,
    Vibration,
    Network,
    Camera,
    Chooser,
    Places,
    Connection,
    SharedService,
    CallService,
    File,
    VideoEditor,
    StreamingMedia,
    Badge,
    InAppBrowser,
    LaunchNavigator,
    CallNumber,
    ScreenOrientation,
    Geolocation
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
